import { Box, Typography } from '@mui/material'
import React from 'react'
import { customStyles } from '../../styles'
import { ENERSI_VERSION } from '../../utils/constants'

export const Footer = () => {
  return (
    <Box sx={{
      position: 'fixed',
      bottom: 0,
      right: 0,
      zIndex: 1200,
      padding: '8px 12px',
      pointerEvents: 'none'
    }}>
      <Typography variant="caption" sx={{ color: customStyles.colors.textColor }}>
        &copy;Globalgas {new Date().getFullYear()} - {ENERSI_VERSION}
      </Typography>
    </Box>
  )
}
